/* Home Sales Landing Hero */
import 'slick-carousel';
import 'select2';
// import Datepicker from 'vanillajs-datepicker/Datepicker';

export function home_sales_landing_hero() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--home-sales-landing-hero' ).length <= 0 ) {
				return;
			}

			$( '.block--home-sales-landing-hero--gallery' ).each( ( i, e ) => {
				const slider = $( e );

				slider.slick( {
					arrows: false,
					autoplay: true,
					autoplaySpeed: 3000,
					dots: false,
					fade: true,
					infinite: true,
					pauseOnFocus: false,
					pauseOnHover: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					swipe: false,
					rows: 0
				} );
			} );

			// Select2 for destinations
			if ( $( '.block--home-sales-landing-hero--widget--all' ).length > 0 ) {
				const selector = $( '.block--home-sales-landing-hero--widget--all' ).find( '#home-sales-community' );

				selector.select2( {
					allowClear: true,
					width: '100%',
					dropdownParent: $( '#home-sales-community' ).parent(),
					ajax: {
						url: '/wp-json/pri-rest-extender/v1/search',
						delay: 750,
						cache: false,
						dataType: 'json',
						data: ( params ) => {
							params.type = 'all';
							return params;
						}
					}
				} );

				const $btnGo = $( '#button-go-to-community', '.block--home-sales-landing-hero--widget--all' );

				$btnGo.on( 'click', ( event ) => {
					event.preventDefault();

					const selected = selector.find( ':selected' );

					if ( 0 == selected.length ) {
						return;
					}

					window.location.pathname = `/community/${selected.val()}`;
				} );
			}

			// Tab button to search home sales or rentals
			$( 'input[name="options"]' ).on( 'change', ( ev ) => {
				const form = $( ev.currentTarget ).parentsUntil( 'form' ).parent();

				switch ( $( ev.currentTarget ).prop( 'id' ) ) {
					case 'option-homes':
						form.prop( 'action', `${window.location.origin}/homes-cottages-for-sale` );
						break;

					case 'option-rentals':
						form.prop( 'action', `${window.location.origin}/rv-sites-rentals` );
						break;
				}
			} );

			// is rentals page
			if ( $( 'body' ).hasClass( 'page-id-20788' ) ) { 
				$( 'label[for="option-rentals"]' ).click();
			}
		}

		init();

	} )( window.jQuery );
}